var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',_vm._l((_vm.formsFiltered),function(item){return _c('v-list-item',{key:item.formName,staticClass:"fifth-forms-list",attrs:{"dense":"","to":'/forms/' + item.formName}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }